import React, { ReactElement, useEffect, useState } from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import CreateActivity from 'pages/Dashboard/Organizer/Event/Activities/CreateActivity';
import DashboardNotFoundPage from 'pages/Dashboard/DashboardNotFoundPage';
import { DashboardWrapper } from 'custom-style-components';
import EditActivity from 'pages/Dashboard/Organizer/Event/Activities/EditActivity';
import EditEvent from 'pages/Dashboard/Organizer/Event/EditEvent';
import EditUserPassword from 'pages/Dashboard/Organizer/Users/EditUser/editPassword';
import ListActivities from 'pages/Dashboard/Organizer/Event/Activities/ListActivities';
import ListEvents from 'pages/Dashboard/Organizer/Event/ListEvents';
import ListOldActivities from 'pages/Dashboard/Organizer/OldEvent/Activities/ListActivities';
import ListOldEvents from 'pages/Dashboard/Organizer/OldEvent/ListEvents';
import ListUsers from 'pages/Dashboard/Organizer/Users/ListUsers';
import { LoadingSpinnerContainer } from 'components/LoadingSpinner/styled';
import MarkPresences from 'pages/Dashboard/Responsible/Activities/MarkPresences';
import { RouteComponentProps } from 'react-router';
import { api } from 'services/axios';
import axios from 'axios';
import { useAuth } from 'hooks/auth';
import { useNav } from 'hooks/navbar';

const EventOrganizerRoute: React.FC<RouteComponentProps> = () => {
    const { user } = useAuth();
    const { updateNavbarOrganizer } = useNav();

    const [canRender, setCanRender] = useState(false);
    const [redirect, setRedirect] = useState<ReactElement>();

    const { path } = useRouteMatch();

    const source = axios.CancelToken.source();

    document.title = 'Controle Organizador do Evento';

    useEffect(() => {
        if (user) {
            api.get(`/user/responsibility/permissions/${user.id}`, {
                cancelToken: source.token,
            })
                .then((res) => {
                    if (res.data.isEventOrganizer) setCanRender(true);
                    else setRedirect(<Redirect to="/" />);
                })
                .catch(() => setRedirect(<Redirect to="/" />));
        }
        return () => {
            source.cancel();
        };
    }, []);

    useEffect(() => {
        if (canRender) {
            updateNavbarOrganizer();
        }
    }, [canRender]);

    return (
        <>
            {redirect}
            {!canRender ? (
                <LoadingSpinnerContainer />
            ) : (
                <DashboardWrapper>
                    <Switch>
                        <Route
                            exact
                            path={path + '/edicoes'}
                            component={ListEvents}
                        />
                        <Route
                            path={path + '/edicoes/:eventId/alterar'}
                            component={EditEvent}
                        />

                        <Route
                            path={path + '/edicoes/:eventId/programacao'}
                            exact
                            component={ListActivities}
                        />
                        <Route
                            path={
                                path +
                                '/edicoes/:eventId/programacao/:activityId/presencas'
                            }
                            component={MarkPresences}
                        />
                        <Route
                            path={
                                path +
                                '/edicoes/:eventId/programacao/criar_atividade'
                            }
                            component={CreateActivity}
                        />
                        <Route
                            path={
                                path +
                                '/edicoes/:eventId/programacao/:activityId/alterar'
                            }
                            component={EditActivity}
                        />

                        <Route
                            exact
                            path={path + '/edicoes_anteriores'}
                            component={ListOldEvents}
                        />
                        <Route
                            path={
                                path +
                                '/edicoes_anteriores/:eventId/programacao'
                            }
                            exact
                            component={ListOldActivities}
                        />
                        <Route
                            path={
                                path +
                                '/edicoes_anteriores/:eventId/programacao/:activityId/inscritos'
                            }
                            exact
                            component={MarkPresences}
                        />

                        <Route 
                            exact 
                            path={path + '/usuarios'} 
                            component={ListUsers} 
                        />

                        <Route
                            exact path={path + '/usuarios/:userId/alterar_senha'}
                            component={EditUserPassword}
                        />

                        <Redirect from={path} to={path + '/edicoes'} exact />
                        <Route path="*" component={DashboardNotFoundPage} />
                    </Switch>
                </DashboardWrapper>
            )}
        </>
    );
};

export default EventOrganizerRoute;
